import { jsx as _jsx } from "react/jsx-runtime";
import './geozone-redactor.sass';
import { memo } from 'react';
import { preventDefault } from 'shared/hooks/utils';
export const ShowGeozoneRedactor = memo(function ShowGeozoneRedactor({ onClick, }) {
    return (_jsx("a", { href: "#", className: "ui-map-draw-geozone-redactor", onClick: (event) => {
            preventDefault(event);
            onClick(event);
        }, title: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0433\u0435\u043E\u0437\u043E\u043D" }));
});
